// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a714b1fd","732":"6c0f4840","977":"b89de794"}[chunkId] + ".chunk.js";
};